import { trapFocus, removeTrapFocus, lockScroll, unlockScroll, closeDrawer, setDrawerOpenAccessibility } from '@theme/theme-global';

const PROMO_MEGA_MENU_SELECTOR = '[data-promotional-banner-mega-menu]';
// const PROMO_BANNER_SELECTOR = '[data-promotionalbanner-megamenu-items]';
// const PROMO_BANNER_ACTIVE_SELECTOR = `${PROMO_BANNER_SELECTOR}.active`;
if (!customElements.get('hamburger-drawer')) {
  class HamburgerDrawer extends HTMLElement {
    constructor() {
      super();

      this.activeElement = null;
      this._drawerBody = this.querySelector('.hamburger-drawer-body');
      this._closeBtn = this.querySelector('.hamburger-drawer-close-btn');
      this._focusTarget = this._drawerBody || this._closeBtn;

      this._handleKeyup = (evt) => {
        if (evt.code !== 'Escape') return;

        const activeSubmenu = this.querySelector('details[is="hamburger-menu-item-details"].active');
        if (activeSubmenu && typeof activeSubmenu.closeSubmenu === 'function') {
          activeSubmenu.closeSubmenu();
          return;
        }

        this.close();
      };



      this.addEventListener('keyup', this._handleKeyup);
      this.setHeaderHamburgerIconAccessibility();
      this.drawerCloseInit();
      // this.initPromotionalBannerMegaMenu();
    }

    setHeaderHamburgerIconAccessibility() {
      const drawerIcon = document.querySelector('#HamburgerDrawerIcon');
      if (!drawerIcon) return;

      drawerIcon.setAttribute('role', 'button');
      drawerIcon.setAttribute('aria-haspopup', 'dialog');

      drawerIcon.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(drawerIcon);
      });

      drawerIcon.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(drawerIcon);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      setDrawerOpenAccessibility(this);
      window.setTimeout(() => {
        this.setAttribute('open', '');
        this.setAttribute('active', '');
      });

      // Trap immediately so a quick drill into level 2 can nest with { push: true }
      // instead of racing a delayed transitionend trap that would replace the stack.
      trapFocus(this, this._focusTarget);
      lockScroll();
    }

    releaseNestedFocusTraps() {
      this.querySelectorAll('details[is="hamburger-menu-item-details"]').forEach((details) => {
        if (!details.classList.contains('active') && !details._submenuTrapActive) return;

        if (typeof details.releaseSubmenuFocus === 'function') {
          details.releaseSubmenuFocus(null, { restoreFocus: false });
        }

        details.parent?.classList.remove('active');
        details.classList.remove('active');
        details.summary?.setAttribute('aria-expanded', 'false');
        details.removeAttribute('open');
      });
    }

    teardownFocusAndScroll() {
      this.closeOtherDetails();
      this.releaseNestedFocusTraps();
      removeTrapFocus(this.activeElement);
      unlockScroll();
    }

    drawerCloseInit() {
      this.querySelectorAll('[is="close-drawer"]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          closeDrawer(event.target);
          // this.removeActivePromotionalBanners();
          this.teardownFocusAndScroll();
        });
      });
    }

    closeOtherDetails(currentDetails = null) {
      this.querySelectorAll('details[is=accordion-details]').forEach((details) => {
        if (details !== currentDetails) {
          details.close();
        }
      });
    }

    close() {
      closeDrawer(this);
      // this.removeActivePromotionalBanners();
      this.teardownFocusAndScroll();
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('hamburger-drawer', HamburgerDrawer);
}


class HamburgerMenuItemDetails extends HTMLDetailsElement {
  constructor() {
    super();
    this._submenuTrapActive = false;
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
    }
  }

  get parent() {
    return this.closest('[data-parent]');
  }

  get summary() {
    return this.querySelector('summary');
  }

  get closeButton() {
    return this.querySelector('[data-back-button]');
  }

  get submenu() {
    return this.querySelector('.hamburger-menu-drawer-submenu');
  }

  onSummaryClick() {
    setTimeout(() => {
      this.parent?.classList.add('active');
      this.classList.add('active');
      this.summary?.setAttribute('aria-expanded', 'true');
      this.trapSubmenuFocus();
    }, 100);
  }

  trapSubmenuFocus() {
    const submenu = this.submenu;
    if (!submenu || this._submenuTrapActive) return;

    const focusTarget = this.closeButton || submenu;
    if (!this.closeButton && submenu.tabIndex < 0) {
      submenu.setAttribute('tabindex', '-1');
    }

    // Nest on top of the drawer trap — level 3 accordion stays inside this container (no extra trap).
    trapFocus(submenu, focusTarget, { push: true });
    this._submenuTrapActive = true;
  }

  releaseSubmenuFocus(returnFocusTo = null, { restoreFocus = true } = {}) {
    if (!this._submenuTrapActive) return;
    this._submenuTrapActive = false;
    if (restoreFocus) {
      removeTrapFocus(returnFocusTo || this.summary);
      return;
    }
    removeTrapFocus(null, { restoreFocus: false });
  }

  closeSubmenu({ restoreFocus = true } = {}) {
    this.parent?.classList.remove('active');
    this.classList.remove('active');
    this.summary?.setAttribute('aria-expanded', 'false');
    this.releaseSubmenuFocus(this.summary, { restoreFocus });
    this.closeAnimation();
    this.querySelectorAll('details[is=accordion-details]').forEach((menu) => {
      menu.close();
    });
  }

  onCloseButtonClick() {
    this.closeSubmenu({ restoreFocus: true });
  }

  closeAnimation() {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        requestAnimationFrame(handleAnimation);
      } else {
        this.removeAttribute('open');
      }
    };

    requestAnimationFrame(handleAnimation);
  }
}
customElements.define('hamburger-menu-item-details', HamburgerMenuItemDetails, { extends: 'details' });
